import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-24 bg-gradient-to-br from-[#F0FFF4] to-white border-t-4 border-[#10B981]" data-id="element-75">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-77">
          <div className="w-24 h-24 bg-[#10B981] rounded-full flex items-center justify-center mx-auto mb-8 shadow-2xl" data-id="element-78">
            <ShieldCheck className="w-12 h-12 text-white" data-id="element-79" />
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-6" data-id="element-80">
            60-Day Money-Back Guarantee
          </h2>

          <p className="text-xl text-[#374151] leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-81">
            Feel lighter, look slimmer, and glow from within — or get every
            penny back. We're confident you'll love LymphoriaX, but if you don't
            see results within 60 days, we'll refund your purchase.{' '}
            <span className="font-bold text-[#10B981]" data-id="element-82">
              No questions asked.
            </span>
          </p>

          <div className="flex justify-center items-center space-x-8 mt-12 flex-wrap gap-4" data-id="element-83">
            <div className="text-center" data-id="element-84">
              <div className="text-4xl mb-2" data-id="element-85">🔒</div>
              <div className="text-sm font-medium text-[#374151]" data-id="element-86">
                Secure Checkout
              </div>
            </div>
            <div className="text-center" data-id="element-87">
              <div className="text-4xl mb-2" data-id="element-88">✅</div>
              <div className="text-sm font-medium text-[#374151]" data-id="element-89">
                60-Day Guarantee
              </div>
            </div>
            <div className="text-center" data-id="element-90">
              <div className="text-4xl mb-2" data-id="element-91">🚚</div>
              <div className="text-sm font-medium text-[#374151]" data-id="element-92">
                Free Shipping
              </div>
            </div>
            <div className="text-center" data-id="element-93">
              <div className="text-4xl mb-2" data-id="element-94">⭐</div>
              <div className="text-sm font-medium text-[#374151]" data-id="element-95">
                12,847+ Reviews
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}